import { Routes } from '@/models/router/router.interface';
import store from '@/store';

class InitialRoutePresenter {
	private get defaultRoute(): Routes {
		return Routes.GENERAL;
	}

	private get idFromUrl(): number {
		const microserviceUrlPart = this.separateStringAndRetrieveHalf(window.location.href, '#');
		const urlSegments = microserviceUrlPart.split('/');
		if (urlSegments.length < 3) {
			return 0;
		}

		const idAsNumber = parseInt(urlSegments[2]);
		if (isNaN(idAsNumber)) {
			return 0;
		}

		return idAsNumber;
	}

	private get routeToShow(): Routes {
		const microserviceUrlPart = this.separateStringAndRetrieveHalf(window.location.href, '#');
		const urlSegments = microserviceUrlPart.split('/');
		if (urlSegments.length < 2) {
			return this.defaultRoute;
		}

		const initialRoute = urlSegments[1];
		const allRoutes: string[] = Object.values(Routes);
		if (!allRoutes.includes(initialRoute)) {
			// Invalid route name, so bail out.
			return this.defaultRoute;
		}

		return initialRoute as Routes;
	}

	public prepareForRoutingActions(): void {
		// Ensure that initially, the right component is shown.
		this.showComponentInLineWithCurrentRoute();
		// Ensure that, when navigation is triggered outside of the microservice, the right component is shown.
		this.respondToExternalRouteChanges();
	}

	private showComponentInLineWithCurrentRoute(): void {
		store.mutations.setCurrentRoute(this.routeToShow, this.idFromUrl);
	}

	private respondToExternalRouteChanges(): void {
		window.addEventListener('hashchange', this.showComponentInLineWithCurrentRoute.bind(this));
	}

	private separateStringAndRetrieveHalf(stringToSeparate: string, separator: string): string {
		const parts = stringToSeparate.split(separator);
		if (parts.length < 2) {
			return '';
		}

		return parts[1];
	}
}

export default new InitialRoutePresenter();
